import {SnSButton} from "./SnSButton.js";

export class GoogleButton extends SnSButton {
    setup() {
        this.$props.isRender = !!window.googleApiAvailable
    }

    getButtonDataJson() {
        return  {
            snsType: "google",
            id : "googleLoginButton",
            className : `login-google`,
            buttonText : i18next.t(login.googlestrt),
        }
    }

    setEvent() {
        const buttonId = this.getButtonDataJson().id;
        const GoogleLogin = Mutil.requireIIFE("GoogleLogin");
        this.addEvent("click.prevent", `#${buttonId}`, (e) => {
            const Often = Mutil.requireIIFE("Often");
            if(Often.isGlobal()) {
                const GoogleTagManager = Mutil.requireIIFE("GoogleTagManager");
                GoogleTagManager?.collect({event: `new_signup2_b`});
            }
            GoogleLogin.clickGoogleLoginButton(e);
        });
    }
}